import { Controller } from "@hotwired/stimulus";

/*
  Converts this:
    <time datetime="2024-12-25T09:00:00+00:00"></time>

  into:
    <time datetime="2024-12-25T09:00:00+00:00">December 25, 2024, 9:00am</time>

  Optionally, you can pass in data attributes:
  - data-time-zone

  See also the localized_timestamp helper method

*/
export default class extends Controller {
  connect() {
    const date = new Date(this.element.getAttribute("datetime"));

    const timeZone =
      this.element.getAttribute("data-time-zone") ||
      document.body.getAttribute("data-time-zone");

    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone,
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    this.element.innerText = formatter
      .format(date)
      .replace(" AM", "am")
      .replace(" PM", "pm");
  }
}
